<template>
  <div class="edit-panel-dailog dialog col-block">
    <customForm
      :init="panelData"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendPanel() : ''">
        <span>{{ panelData.id ? $t('COMMON.button.___update') : $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { postPhenotypePanel, putPhenotypePanel } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      panelData: {
        panel: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.$t('DIALOG.editPanel.form.title.___panel'),
            value: 'panel',
            type: 'input',
            placeholder: () => this.$t('DIALOG.editPanel.form.placeholder.___panel'),
            validate: 'required'
          }
        ]
      }
    }
  },
  created () {
    let panelData = this.param.panel || this.panelData
    this.panelData = panelData
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.panelData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendPanel () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendPanel()
      }
      this.onSubmit = false
    },
    async sendPanel () {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.panelData.id
        let data = this.result
        let response = id ? await putPhenotypePanel(id, data, config) : await postPhenotypePanel(data, config)
        this.addToast('success', response.data.result.message)
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editPanel.vue